export default {
    selectGroupContainer: {
        display: "flex",
        flexDirection: "column",
        flexWrap: "wrap",
        gap: "40px",
        margin: "80px 0px",
    }
}